import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import "@/App.css";
import Landing from "@/pages/Landing";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Battle from "@/pages/Battle";
import Leaderboard from "@/pages/Leaderboard";
import Tournaments from "@/pages/Tournaments";
import Social from "@/pages/Social";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [agent, setAgent] = useState(null);
  const [manaverse, setManaverse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored session on app load
    const storedAgent = localStorage.getItem('agent');
    const storedManaverse = localStorage.getItem('manaverse');
    const sessionTimestamp = localStorage.getItem('sessionTimestamp');
    
    if (storedAgent && storedManaverse) {
      // Check if session is still valid (7 days)
      const now = Date.now();
      const sessionAge = sessionTimestamp ? now - parseInt(sessionTimestamp) : 0;
      const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;
      
      if (sessionAge < sevenDaysInMs) {
        // Auto-login with stored credentials
        setAgent(JSON.parse(storedAgent));
        setManaverse(JSON.parse(storedManaverse));
      } else {
        // Session expired, clear storage
        localStorage.removeItem('agent');
        localStorage.removeItem('manaverse');
        localStorage.removeItem('sessionTimestamp');
      }
    }
    setLoading(false);
  }, []);

  const handleLogin = (agentData, manaverseData) => {
    setAgent(agentData);
    setManaverse(manaverseData);
    localStorage.setItem('agent', JSON.stringify(agentData));
    localStorage.setItem('manaverse', JSON.stringify(manaverseData));
    localStorage.setItem('sessionTimestamp', Date.now().toString());
  };

  const handleLogout = () => {
    setAgent(null);
    setManaverse(null);
    localStorage.removeItem('agent');
    localStorage.removeItem('manaverse');
    localStorage.removeItem('sessionTimestamp');
  };

  if (loading) {
    return (
      <div className="App">
        <div className="min-h-screen cosmic-bg flex items-center justify-center">
          <div className="text-white font-unbounded text-2xl">Loading Manaverse...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/register" element={<Register onLogin={handleLogin} />} />
          <Route
            path="/dashboard"
            element={agent ? <Dashboard agent={agent} manaverse={manaverse} onLogout={handleLogout} /> : <Navigate to="/" />}
          />
          <Route
            path="/battle"
            element={agent ? <Battle agent={agent} manaverse={manaverse} /> : <Navigate to="/" />}
          />
          <Route
            path="/leaderboard"
            element={<Leaderboard agent={agent} />}
          />
          <Route
            path="/tournaments"
            element={<Tournaments agent={agent} />}
          />
          <Route
            path="/social"
            element={<Social agent={agent} />}
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;